export default __webpack_public_path__ + "static/media/pic1.ff20f89f.jpg";